import angular from 'angular';
import { bitUrlBuilderModule } from '../../../shared/services/bitUrlBuilder/bitUrlBuilder.module';
import { geoLocationModule } from '../geoLocation/geoLocation.module';
import { bitApiFactory } from './bitApi.factory';

export const bitApiModule = angular
  .module('bit.services.bitApi', [
    geoLocationModule.name,
    bitUrlBuilderModule.name,
  ])
  .factory('bitApi', bitApiFactory);
